import * as AppRouting from "appRouting";
import * as Api from "user/user/api";
import * as User from "user/user/User";
import * as Dto from "user/user/dto";
//-------------------------------------------------------------------------------------------------------------------------------
export const USER_LOGIN = "USER_LOGIN";
export const USER_FETCH_DATA = "USER_FETCH_DATA";
export const USER_SET_DATA = "USER_SET_DATA";
export const USER_LOGOUT = "USER_LOGOUT";
export function createAction_User_Login(mobile) {
    return {
        type: USER_LOGIN,
        mobile: mobile
    };
}
export function createAction_FetchingUserData() {
    return {
        type: USER_FETCH_DATA
    };
}
export function createAction_User_SetData(userDto) {
    return {
        type: USER_SET_DATA,
        userInfo: User.createUserInfo(userDto.userInfo),
        loginUserType: userDto.loginUserType,
        userAccess: User.createAccessFromDto(userDto.access)
    };
}
export const getUserDataStartUp = (dispatch) => {
    dispatch(createAction_FetchingUserData());
    return Api.async_getUserDataStartUp(dispatch)
        .then((userFromServerDto) => {
        // Add user data
        dispatch(createAction_User_SetData(userFromServerDto));
        // Redirect if theres only single access for the user
        if (userFromServerDto.access.length == 1) {
            if (userFromServerDto.access[0].type == Dto.EntryTypeDto.Agency) {
                AppRouting.agencyNavigate(dispatch, userFromServerDto.access[0].id);
            }
            else if (userFromServerDto.access[0].type == Dto.EntryTypeDto.Office) {
                AppRouting.officeNavigate(dispatch, userFromServerDto.access[0].id);
            }
        }
        // Identify user for Zendesk chat
        zE.identify({
            name: `${userFromServerDto.userInfo.firstName} ${userFromServerDto.userInfo.lastName}`,
            email: userFromServerDto.userInfo.email
        });
        return Promise.resolve();
    }, (allowRedirect) => {
        if (allowRedirect) {
            // Navigate to login
            AppRouting.loginNavigate(dispatch);
        }
        return Promise.reject("");
    });
};
export function createAction_User_Logout() {
    return {
        type: USER_LOGOUT
    };
}
